function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { useForm } from 'react-hook-form';
import convertFormDataToChangePasswordRequest from 'shared/view/change-password-request-conversion-service';
import { Controls, validators, useFormHelpers } from 'shared/helper/form';
import { PASSWORD_MIN_LENGTH } from 'shared/helper/form/validators';
import { T } from 'shared/helper/translate';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import FormSubmit from './FormSubmit';
var Form = Controls.Form,
  MultiFieldValidation = Controls.MultiFieldValidation,
  Password = Controls.Password;
var notEmpty = validators.notEmpty,
  validPassword = validators.validPassword;
var passwordsMatch = function passwordsMatch(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    password = _ref2[0],
    passwordConfirmation = _ref2[1];
  return password === passwordConfirmation;
};
var defaultValues = {
  currentPassword: '',
  password: '',
  passwordConfirmation: ''
};
var styles = {
  wrapper: 'mb-3'
};
var ChangePasswordForm = function ChangePasswordForm(_ref3) {
  var apiRoot = _ref3.apiRoot,
    displayCurrentPassword = _ref3.displayCurrentPassword,
    status = _ref3.status,
    updatePassword = _ref3.updatePassword,
    userIdentity = _ref3.userIdentity;
  var methods = useForm({
    defaultValues: defaultValues
  });
  var _useFormHelpers = useFormHelpers(methods),
    preprocessData = _useFormHelpers.preprocessData;
  var handleSubmit = function handleSubmit(changePasswordRequest) {
    trackRubriqEvent('User Updated Password', {
      userId: userIdentity.id
    });
    updatePassword(apiRoot, userIdentity, changePasswordRequest);
  };
  return /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: preprocessData(convertFormDataToChangePasswordRequest, handleSubmit)
  }, /*#__PURE__*/React.createElement(MultiFieldValidation, {
    name: "passwordValid",
    messages: {
      passwordsMatch: 'Non-matching passwords error'
    },
    validators: {
      passwordsMatch: passwordsMatch
    },
    fields: ['password', 'passwordConfirmation']
  }), displayCurrentPassword ? /*#__PURE__*/React.createElement(Password, {
    name: "currentPassword",
    label: "Old password",
    styles: styles,
    showToggle: false,
    messages: {
      notEmpty: 'Please enter your current password.'
    },
    validators: {
      notEmpty: notEmpty
    }
  }) : null, /*#__PURE__*/React.createElement(Password, {
    name: "password",
    label: "New password",
    styles: styles,
    showToggle: false,
    messages: {
      validPassword: function validPassword() {
        return /*#__PURE__*/React.createElement(T, {
          source: "password-too-short",
          params: PASSWORD_MIN_LENGTH
        });
      }
    },
    validators: {
      validPassword: validPassword
    }
  }), /*#__PURE__*/React.createElement(Password, {
    name: "passwordConfirmation",
    label: "Confirm new password",
    styles: styles,
    showToggle: false,
    messages: {
      validPassword: function validPassword() {
        return /*#__PURE__*/React.createElement(T, {
          source: "password-too-short",
          params: PASSWORD_MIN_LENGTH
        });
      }
    },
    validators: {
      validPassword: validPassword
    }
  }), /*#__PURE__*/React.createElement(FormSubmit, {
    disable: status.updating || !status.loaded,
    busy: status.updating
  }));
};
export default ChangePasswordForm;